import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationPT from './locales/pt/translation.json';
import translationES from './locales/es/translation.json';

const LANGUAGE_STORAGE_KEY = 'farmacia_i18n_language';

function readStoredLanguage(): string {
  try {
    const v = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (v === 'en' || v === 'es' || v === 'pt') return v;
  } catch {
    /* ignore */
  }
  return 'pt';
}

i18n.use(initReactI18next).init({
  fallbackLng: 'pt',
  lng: readStoredLanguage(),
  resources: {
    en: {
      translation: translationEN,
    },
    pt: {
      translation: translationPT,
    },
    es: {
      translation: translationES,
    },
  },
});

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  } catch {
    /* ignore */
  }
});

export default i18n;
